import get from 'lodash/get'

export const getNodeStatus = (node) => {
  if (!node.lastSeenAt) return 'unknown'
  const lastSeen = new Date(node.lastSeenAt)
  const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000)
  return lastSeen > fiveMinutesAgo ? 'online' : 'offline'
}

export const getStatusColor = (status) => {
  switch (status) {
    case 'online':
      return 'success'
    case 'offline':
      return 'error'
    default:
      return 'default'
  }
}

export const getLoadLevel = (latestStatus) => {
  const cpu = get(latestStatus, 'cpuUtilization', 0)
  const memory = get(latestStatus, 'memoryUtilization', 0)
  const disk = get(latestStatus, 'diskUtilization', 0)
  const maxUtilization = Math.max(cpu, memory, disk)

  if (maxUtilization >= 85) return 'critical'
  if (maxUtilization >= 60) return 'warning'
  return 'healthy'
}

export const getLoadColor = (loadLevel) => {
  switch (loadLevel) {
    case 'critical':
      return 'error.main'
    case 'warning':
      return 'warning.main'
    default:
      return 'success.main'
  }
}
